import { render, staticRenderFns } from "./TokenPricedVisibleToggleButton.vue?vue&type=template&id=93b3a620"
import script from "./TokenPricedVisibleToggleButton.vue?vue&type=script&lang=ts"
export * from "./TokenPricedVisibleToggleButton.vue?vue&type=script&lang=ts"
import style0 from "./TokenPricedVisibleToggleButton.vue?vue&type=style&index=0&id=93b3a620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports